import { Injectable } from '@angular/core';
import { Folder, MatterFileType } from '@models/matter';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './folders.actions';

@Injectable({
	providedIn: 'root',
})
export class BusinessFoldersDispatch {
	@Dispatch()
	Remove = (folderId: string): actions.Remove => new actions.Remove(folderId);
}
